import React, { useEffect, useMemo, useState } from 'react';
import c from 'classnames';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';

import { cloneDeep } from 'lodash';
// import { Button } from '@material-ui/core';
import Layout from '../../components/Layout';
import FilterBar from '../../components/FilterBarAnalytics';
import { getStaticTextAnalytics } from './constants';
import Loader from '../../components/Loader';
import { getStaticText } from '../../utils/constants';
import './index.scss';
import Intro from './Intro/Intro';
import Overview from './Overview';
import Scorecard from './Scorecard';
import FlagPole from './Flagpole';
import PracticeRanking from './PracticeRanking';
import viewIcon from '../Reports/assets/viewIcon.svg';
import FocusArea from '../Diagnose/assets/FocusArea.svg';
import DifferentiatorAnalysises from './DifferentiatorAnalysises';
// import PenWhite from '../../assets/Pen-White.svg';
// import SmallDown from '../../assets/smallDown.svg';
import Feedback from '../Diagnose/Feedback';
import CustomBenchmark from './CustomBenchmarks';
import AuthStore from '../../common/AuthStore';
// import { ChatBot } from '@ohi/genai-fe';
import getFilterString, { getMaxRange } from './assets/functions';
import RealtimeDatabase from './RealtimeDatabase';
import RealtimeFilterBar from './RealtimeFilterBar';

function Analytics({
    analyticsApiCount,
    updateFilters,
    filters,
    filtersApplied,
    filtersFetched,
    getFilterData,
    defaultSettings,
    filterParams,
    dataAtGlanceFetched,
    getDataAtGlance,
    getFiltersMapping,
    filtersMapping,
    filtersMappingFetched,
    defaultFilters,
    getDefaultYear,
    defaultYear,
    diagnoseApiCount,
    range,
    setOrgSizeData,
    dataAtGlance,
    getRealtimeYear,
    defaultRealTimeYear,
    getRealtimeAnalytics,
    realtimeTotalData,
    getRealtimeSurveyList,
    realtimeSurveyList,
    getRealtimeFilters,
    realtimeFiltersData,
    realtimeDefaultFiltersData,
    realtimeFiltersParams,
    realtimeFilterDataFetched,
    realtimeTotalDataFetched,
    realtimeSurveyListFetched,
    updateRealtimeFilters,
    realtimeFiltersApplied,
}) {
    const { lang } = defaultSettings;
    const staticTextAnalytics = getStaticTextAnalytics(lang);
    const { DEFAULT_FILTER, NAV_LINKS, DEFAULT_REALTIME_FILTER } = staticTextAnalytics;
    const staticText = getStaticText(lang);
    const { SITE_TEXT, SLICE_VALUE } = staticText;
    const [activeIndex, updateIndex] = useState(0);
    const [filterOpen, toggleFilterView] = useState(false);
    const [tabs, setTabs] = useState(4);
    const [rankingTabs, setRankingTabs] = useState(0);
    const [sliceVal, setSliceVal] = useState(SLICE_VALUE);
    const { ANALYTICS_NAV_LINKS, VIEW_LESS, VIEW_MORE, FILTERS_APPLIED } = SITE_TEXT || {};
    const isDiffAnalysisScreen = activeIndex === 4 && rankingTabs === 1;
    const [feedbackOpen, toggleFeedbackView] = useState(false);
    const { gsodApprover } = AuthStore;
    const isApprover = gsodApprover === 'true';
    const [tabCB, setTabCB] = useState(isApprover ? 1 : 0);
    const [modal, viewModal] = useState(true);
    // const isClient = userRole === USER_ROLES.CLIENT;
    // const token = accessToken.split(' ')[1];

    // const showFilterPanel = range?.totalcomplete?.[0] === 0 && range?.totalcomplete?.[1] === 165416;
    // const showFilterPanel2 = range?.totalcomplete?.[0] === 0 && range?.totalcomplete?.[1] === '';
    // const showFilterPanel3 = range.totalinvited[0] === 0 && range.totalinvited[1] === 165416;
    // const showFilterPanel4 = range.totalinvited[0] === 0 && range.totalinvited[1] === '';

    const [warningModal, setWarningModal] = useState(false);
    const [showWarningIntroModal, setWarningIntroModal] = useState(true);
    const { gsodRole = '' } = AuthStore;
    const gsodRoles = gsodRole === 'AccessLevels.asset_leader';
    const [realtimePopup, realtimeToggleFilterView] = useState(false);

    const role = gsodRole === 'AccessLevels.asset_leader';

    useEffect(() => {
        if (!defaultYear) {
            getDefaultYear();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (gsodRoles && !defaultRealTimeYear) {
            getRealtimeYear();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!realtimeFilterDataFetched && defaultRealTimeYear) {
            getRealtimeFilters(defaultRealTimeYear);
        }
        // eslint-disable-next-line
    }, [realtimeFilterDataFetched, defaultRealTimeYear]);

    useEffect(() => {
        if (defaultRealTimeYear && !realtimeTotalDataFetched) {
            // getRealtimeAnalytics(`year:${defaultRealTimeYear}`);
            const realTimeYear = realtimeFiltersParams === '' ? `year:${defaultRealTimeYear}` : realtimeFiltersParams;
            getRealtimeAnalytics(realTimeYear);
        }
        // eslint-disable-next-line
    }, [realtimeTotalDataFetched, defaultRealTimeYear]);

    useEffect(() => {
        if (defaultRealTimeYear && !realtimeSurveyListFetched) {
            // getRealtimeSurveyList(`year:${defaultRealTimeYear}`);
            const realTimeYear = realtimeFiltersParams === '' ? `year:${defaultRealTimeYear}` : realtimeFiltersParams;
            getRealtimeSurveyList(realTimeYear);
        }
        // eslint-disable-next-line
    }, [realtimeSurveyListFetched, defaultRealTimeYear]);

    useEffect(() => {
        if (!filtersFetched && defaultYear) {
            // getFilterData(defaultYear);
            getFilterData({ year: defaultYear, role });
        }
        // eslint-disable-next-line
    }, [filtersFetched, defaultYear, role]);

    // const updatedFilterss = useMemo(() => {
    //     return filters.map(filter => {
    //         if (filter.filter_id === 'year') {
    //             if (role) {
    //                 return {
    //                     ...filter,
    //                     filter_items: [
    //                         { filter_item_id: 2025, filter_item_name: 2025, allowSelect: true },
    //                         ...filter.filter_items,
    //                     ],
    //                 };
    //             }
    //             return {
    //                 ...filter,
    //                 filter_items: filter.filter_items.filter(item => item.filter_item_id !== 2025),
    //             };
    //         }
    //         return filter;
    //     });
    // }, [filters, role]);

    useEffect(() => {
        if (!filtersMappingFetched && defaultYear) {
            getFiltersMapping(defaultYear);
        }
        // eslint-disable-next-line
    }, [filtersMappingFetched, defaultYear]);

    useEffect(() => {
        if (!dataAtGlanceFetched && defaultYear) {
            getDataAtGlance(filterParams);
        }
        // eslint-disable-next-line
    }, [dataAtGlanceFetched, defaultYear]);

    const setFilters = (newFilters, filtersAppliedFlag) => {
        toggleFilterView(false);
        updateFilters({ filters: newFilters, filtersApplied: filtersAppliedFlag });
    };

    const setRealtimeFilters = (newFilters, filtersAppliedFlag) => {
        realtimeToggleFilterView(false);
        updateRealtimeFilters({ filters: newFilters, filtersApplied: filtersAppliedFlag });
    };

    const updateFilterState = (index, childCode) => {
        const newFilterItem = cloneDeep(filters[index]);
        const selectedItemIndex = newFilterItem.filter_items.findIndex(
            ({ filter_item_id: code }) => code === childCode
        );
        newFilterItem.filter_items[selectedItemIndex].isSelected = false;
        const checkSelectedChild = newFilterItem.filter_items.filter(({ isSelected = false }) => isSelected).length;
        if (!checkSelectedChild) {
            newFilterItem.isSelected = false;
        }
        const newList = [...filters.slice(0, index), newFilterItem, ...filters.slice(index + 1)];
        updateFilters({ filters: newList });
    };

    const updateRealtimeFilterState = (index, childCode) => {
        const newFilterItem = cloneDeep(realtimeFiltersData[index]);
        const selectedItemIndex = newFilterItem.filter_items.findIndex(
            ({ filter_item_id: code }) => code === childCode
        );
        newFilterItem.filter_items[selectedItemIndex].isSelected = false;
        const checkSelectedChild = newFilterItem.filter_items.filter(({ isSelected = false }) => isSelected).length;
        if (!checkSelectedChild) {
            newFilterItem.isSelected = false;
        }
        const newList = [
            ...realtimeFiltersData.slice(0, index),
            newFilterItem,
            ...realtimeFiltersData.slice(index + 1),
        ];
        updateRealtimeFilters({ filters: newList });
    };

    const closeSurveySize = id => {
        const maxRange = getMaxRange(defaultFilters, id) || 165416;
        setOrgSizeData({
            ...range,
            [id]: [0, maxRange],
        });
        const newFilterItem1 = cloneDeep(filters[2]);
        newFilterItem1.isSelected = false;
        const newFilterList = [...filters.slice(0, 2), newFilterItem1, ...filters.slice(2 + 1)];
        updateFilters({ filters: newFilterList });
    };

    const closeResurveySurveySize = () => {
        const maxRangeTotalComplete = getMaxRange(realtimeDefaultFiltersData, 'totalcomplete') || 165416;
        const maxRangeTotalInvited = getMaxRange(realtimeDefaultFiltersData, 'totalinvited') || 165416;
        setOrgSizeData({
            totalcomplete: [0, maxRangeTotalComplete],
            totalinvited: [0, maxRangeTotalInvited],
        });
        const newFilterItem1 = cloneDeep(realtimeFiltersData[2]);
        newFilterItem1.isSelected = false;
        const newFilterList = [...realtimeFiltersData.slice(0, 2), newFilterItem1, ...realtimeFiltersData.slice(2 + 1)];
        updateRealtimeFilters({ filters: newFilterList });
    };

    // Check if survey size filter was manually applied (not at default range)
    const defaultMaxRange = getMaxRange(realtimeDefaultFiltersData, 'totalcomplete') || 165416;
    const isSurveySizeManuallyApplied =
        range?.totalcomplete?.[0] !== undefined &&
        range?.totalcomplete?.[1] !== undefined &&
        range?.totalcomplete?.[1] !== '' &&
        !(range?.totalcomplete?.[0] === 0 && range?.totalcomplete?.[1] === defaultMaxRange);

    const isFiltersApplied = filterParams.replace(DEFAULT_FILTER, '').length;
    const isRealtimeFiltersApplied = realtimeFiltersParams.replace(DEFAULT_REALTIME_FILTER, '').length;
    // const resetFilters = () => {
    //     const newFilters = filters.map(filterItem => {
    //         const updatedFilter = cloneDeep(filterItem);
    //         const { filter_items = [], isDefault = false } = updatedFilter;
    //         if (isDefault) return updatedFilter;
    //         const selectedLength = filter_items.filter(({ isSelected }) => isSelected).length;
    //         if (selectedLength) {
    //             updatedFilter.filter_items = filter_items.map(oldOption => ({
    //                 ...oldOption,
    //                 isSelected: false,
    //             }));
    //         }
    //         updatedFilter.isSelected = false;
    //         return updatedFilter;
    //     });
    //     updateFilters({ filters: newFilters });
    //     setSliceVal(SLICE_VALUE);
    // };

    const renderSliderFilter = () => {
        const sliderFilterIds = ['totalcomplete', 'totalinvited'];
        const defaultMaxById = {
            totalcomplete: getMaxRange(filters, 'totalcomplete') || 165416,
            totalinvited: getMaxRange(filters, 'totalinvited') || 165416,
        };

        return sliderFilterIds.map(filterId => {
            const rangeValues = range?.[filterId];
            const defaultMax = defaultMaxById[filterId];
            const isDefaultRange =
                !rangeValues ||
                rangeValues[1] === '' ||
                (Number(rangeValues[0]) === 0 && Number(rangeValues[1]) === Number(defaultMax));

            if (isDefaultRange) {
                return null;
            }

            const { filter_name: filterName = '' } = filters?.find(({ filter_id: id }) => id === filterId) || {};

            if (!filterName) {
                return null;
            }

            return (
                <div className="filterContent" key={filterId}>
                    <div className="filterHighlight filterKey filterLab">
                        {filterName} - {`${rangeValues[0]} - ${rangeValues[1]}`}
                    </div>
                    <img src={FocusArea} alt="" className="filterImg" onClick={() => closeSurveySize(filterId)} />
                </div>
            );
        });
    };

    const renderfilterApplied = useMemo(() => {
        const selectedFilters = [];
        filters.forEach(({ filter_items, filter_id }) => {
            const skipFilter =
                (filter_id === 'quartile' && isDiffAnalysisScreen) ||
                filter_id === 'totalcomplete' ||
                filter_id === 'totalinvited';
            if (!skipFilter) {
                filter_items.forEach(({ isSelected = false, filter_item_id }) => {
                    if (isSelected) {
                        selectedFilters.push(`${filter_id}_${filter_item_id}`);
                    }
                });
            }
        });
        return (
            <div className="filterAppliedContent">
                <div className="filterDemo">
                    <div className="heading">{FILTERS_APPLIED}:</div>
                    {filters.map(
                        (
                            { filter_name, isSelected = false, filter_items = [], filter_id, isDefault = false },
                            index
                        ) => {
                            if (!isSelected) return null;
                            return filter_items.map(
                                ({ isSelected: selectedChild = false, filter_item_name, filter_item_id }) => {
                                    const checkLimit = selectedFilters
                                        .slice(0, sliceVal)
                                        .includes(`${filter_id}_${filter_item_id}`);
                                    return selectedChild && checkLimit ? (
                                        <div className="filterContent" key={filter_item_name + filter_item_id}>
                                            <Tooltip
                                                title={`${filter_name} - ${filter_item_name}`}
                                                arrow
                                                placement="top"
                                            >
                                                <div className="filterHighlight filterKey filterLab">
                                                    {filter_name} - {filter_item_name}
                                                </div>
                                            </Tooltip>
                                            {!isDefault && (
                                                <img
                                                    src={FocusArea}
                                                    alt=""
                                                    className="filterImg"
                                                    onClick={() => updateFilterState(index, filter_item_id)}
                                                />
                                            )}
                                        </div>
                                    ) : null;
                                }
                            );
                        }
                    )}
                    {/* {filters
                        .filter(
                            ({ filter_id }) =>
                                (filter_id === 'totalcomplete' && !showFilterPanel) ||
                                (filter_id === 'totalinvited' && !showFilterPanel3)
                        )
                        .map(({ filter_name = '', filter_id }) => (
                            <div className="filterContent" key={filter_name}>
                                <div className="filterHighlight filterKey filterLab">
                                    {filter_name} - {`${range[filter_id][0]} - ${range[filter_id][1]}`}
                                </div>
                                <img
                                    src={FocusArea}
                                    alt=""
                                    className="filterImg"
                                    onClick={() => closeSurveySize(filter_id)}
                                />
                            </div>
                        ))} */}
                    {renderSliderFilter()}
                    {/* {!showFilterPanel2 && !showFilterPanel ? (
                        <div className="filterContent">
                            <div className="filterHighlight filterKey filterLab">
                                Survey size - {`${range[0]} - ${range[1]}`}
                            </div>
                            <img src={FocusArea} alt="" className="filterImg" onClick={() => closeSurveySize()} />
                        </div>
                    ) : null} */}

                    {selectedFilters.length >= sliceVal ? (
                        <div className="viewIconContent" onClick={() => setSliceVal(10000)}>
                            <img src={viewIcon} alt="" className="viewImg" />
                            <div className="viewText">{VIEW_MORE}</div>
                        </div>
                    ) : null}
                    {sliceVal === 10000 ? (
                        <div className="viewIconContent" onClick={() => setSliceVal(SLICE_VALUE)}>
                            <img src={viewIcon} alt="" className="viewImg" />
                            <div className="viewText"> {VIEW_LESS}</div>
                        </div>
                    ) : null}
                </div>
            </div>
        );
        // eslint-disable-next-line
    }, [filters, sliceVal, isDiffAnalysisScreen, range]);

    // Create filter string for API calls
    const realtimeFilterString = useMemo(() => {
        // Filter out quartile and totalcomplete/totalinvited filters (handled separately via range)
        const filtersToProcess = realtimeFiltersData.filter(({ filter_id }) => {
            const skipFilter =
                (filter_id === 'quartile' && isDiffAnalysisScreen) ||
                filter_id === 'totalcomplete' ||
                filter_id === 'totalinvited';
            return !skipFilter;
        });
        let filterString = getFilterString(filtersToProcess) || `year:${defaultRealTimeYear}`;

        // Add totalcomplete and totalinvited from range if valid
        const hasValidTotalComplete =
            range?.totalcomplete?.[0] !== undefined &&
            range?.totalcomplete?.[1] !== undefined &&
            range?.totalcomplete?.[1] !== '';
        const hasValidTotalInvited =
            range?.totalinvited?.[0] !== undefined &&
            range?.totalinvited?.[1] !== undefined &&
            range?.totalinvited?.[1] !== '';

        if (hasValidTotalComplete) {
            filterString += `;totalcomplete:${range.totalcomplete[0]},${range.totalcomplete[1]}`;
        }
        if (hasValidTotalInvited) {
            filterString += `;totalinvited:${range.totalinvited[0]},${range.totalinvited[1]}`;
        }

        return filterString;
    }, [realtimeFiltersData, isDiffAnalysisScreen, defaultRealTimeYear, range]);

    const renderRealtimeFilterApplied = useMemo(() => {
        const selectedFilters = [];
        realtimeFiltersData.forEach(({ filter_items, filter_id }) => {
            const skipFilter = (filter_id === 'quartile' && isDiffAnalysisScreen) || filter_id === 'totalcomplete';
            if (!skipFilter) {
                filter_items.forEach(({ isSelected = false, filter_item_id }) => {
                    if (isSelected) {
                        selectedFilters.push(`${filter_id}_${filter_item_id}`);
                    }
                });
            }
        });
        return (
            <div className="filterAppliedContent">
                <div className="filterDemo">
                    <div className="heading">{FILTERS_APPLIED}:</div>
                    {realtimeFiltersData.map(
                        (
                            { filter_name, isSelected = false, filter_items = [], filter_id, isDefault = false },
                            index
                        ) => {
                            if (!isSelected) return null;
                            return filter_items.map(
                                ({ isSelected: selectedChild = false, filter_item_name, filter_item_id }) => {
                                    const checkLimit = selectedFilters
                                        .slice(0, sliceVal)
                                        .includes(`${filter_id}_${filter_item_id}`);
                                    return selectedChild && checkLimit ? (
                                        <div className="filterContent" key={filter_item_name + filter_item_id}>
                                            <Tooltip
                                                title={`${filter_name} - ${filter_item_name}`}
                                                arrow
                                                placement="top"
                                            >
                                                <div className="filterHighlight filterKey filterLab">
                                                    {filter_name} - {filter_item_name}
                                                </div>
                                            </Tooltip>
                                            {!isDefault && (
                                                <img
                                                    src={FocusArea}
                                                    alt=""
                                                    className="filterImg"
                                                    onClick={() => updateRealtimeFilterState(index, filter_item_id)}
                                                />
                                            )}
                                        </div>
                                    ) : null;
                                }
                            );
                        }
                    )}
                    {/* Show Survey size filter only if user manually applied it (not at default 0-165416) */}
                    {isSurveySizeManuallyApplied && (
                        <div className="filterContent">
                            <Tooltip
                                title={`Survey size - ${range?.totalcomplete?.[0]} - ${range?.totalcomplete?.[1]}`}
                                arrow
                                placement="top"
                            >
                                <div className="filterHighlight filterKey filterLab">
                                    Survey size - {`${range?.totalcomplete?.[0]} - ${range?.totalcomplete?.[1]}`}
                                </div>
                            </Tooltip>
                            <img
                                src={FocusArea}
                                alt=""
                                className="filterImg"
                                onClick={() => closeResurveySurveySize()}
                            />
                        </div>
                    )}

                    {selectedFilters.length >= sliceVal ? (
                        <div className="viewIconContent" onClick={() => setSliceVal(10000)}>
                            <img src={viewIcon} alt="" className="viewImg" />
                            <div className="viewText">{VIEW_MORE}</div>
                        </div>
                    ) : null}
                    {sliceVal === 10000 ? (
                        <div className="viewIconContent" onClick={() => setSliceVal(SLICE_VALUE)}>
                            <img src={viewIcon} alt="" className="viewImg" />
                            <div className="viewText"> {VIEW_LESS}</div>
                        </div>
                    ) : null}
                </div>
            </div>
        );
        // eslint-disable-next-line
    }, [realtimeFiltersData, sliceVal, isDiffAnalysisScreen, range]);

    const gsodRealtimeCheck = gsodRoles ? NAV_LINKS : NAV_LINKS.slice(0, 7);

    const getPage = () => {
        let page;
        switch (activeIndex) {
            case 0:
            default:
                page = (
                    <Intro
                        updateTab={updateIndex}
                        defaultYear={defaultYear}
                        showWarningIntroModal={showWarningIntroModal}
                        setWarningIntroModal={setWarningIntroModal}
                        setWarningModal={setWarningModal}
                        warningModal={warningModal}
                    />
                );
                break;
            case 1:
                page = (
                    <Overview
                        toggleFilterView={toggleFilterView}
                        tabs={tabs}
                        setTabs={setTabs}
                        renderfilterApplied={renderfilterApplied}
                        filtersApplied={isFiltersApplied}
                        setWarningModal={setWarningModal}
                        warningModal={warningModal}
                    />
                );
                break;
            case 2:
                page = (
                    <Scorecard
                        toggleFilterView={toggleFilterView}
                        renderfilterApplied={renderfilterApplied}
                        filtersApplied={isFiltersApplied}
                        filters={filters}
                        warningModal={warningModal}
                        setWarningModal={setWarningModal}
                    />
                );
                break;
            case 3:
                page = (
                    <FlagPole
                        toggleFilterView={toggleFilterView}
                        renderfilterApplied={renderfilterApplied}
                        filtersApplied={isFiltersApplied}
                        filters={filters}
                        defaultYear={defaultYear}
                        warningModal={warningModal}
                        setWarningModal={setWarningModal}
                    />
                );
                break;
            case 4:
                page = (
                    <PracticeRanking
                        toggleFilterView={toggleFilterView}
                        renderfilterApplied={renderfilterApplied}
                        tab={rankingTabs}
                        setTab={setRankingTabs}
                        filtersApplied={isFiltersApplied}
                        warningModal={warningModal}
                        setWarningModal={setWarningModal}
                    />
                );
                break;
            case 5:
                page = (
                    <DifferentiatorAnalysises
                        toggleFilterView={toggleFilterView}
                        renderfilterApplied={renderfilterApplied}
                        tab={rankingTabs}
                        setTab={setRankingTabs}
                        filtersApplied={isFiltersApplied}
                        getDataAtGlance={getDataAtGlance}
                        dataAtGlanceFetched={dataAtGlanceFetched}
                        dataAtGlance={dataAtGlance}
                        warningModal={warningModal}
                        setWarningModal={setWarningModal}
                    />
                );
                break;
            case 6:
                page = (
                    <CustomBenchmark
                        toggleFilterView={toggleFilterView}
                        renderfilterApplied={renderfilterApplied}
                        filtersApplied={isFiltersApplied}
                        filters={filters}
                        defaultYear={defaultYear}
                        tab={tabCB}
                        setTab={setTabCB}
                        modal={modal}
                        viewModal={viewModal}
                    />
                );
                break;
            case 7:
                page = (
                    <RealtimeDatabase
                        defaultSettings={defaultSettings}
                        defaultRealTimeYear={defaultRealTimeYear}
                        realtimeTotalData={realtimeTotalData}
                        realtimeSurveyList={realtimeSurveyList}
                        getRealtimeYear={getRealtimeYear}
                        getRealtimeSurveyList={getRealtimeSurveyList}
                        getRealtimeAnalytics={getRealtimeAnalytics}
                        // new
                        // renderfilterApplied={renderfilterApplied}
                        realtimeToggleFilterView={realtimeToggleFilterView}
                        renderRealtimeFilterApplied={renderRealtimeFilterApplied}
                        realtimeFilterString={realtimeFilterString}
                        realtimeFiltersApplied={isRealtimeFiltersApplied}
                    />
                );
                break;
        }
        return page;
    };

    return (
        <Layout showHeader showBenchTab={false}>
            <div
                className={c('analyticsContent clearfix', {
                    isNonProfit: false,
                    hideAddOns: true,
                })}
            >
                <ul className={c({ isLoading: false })}>
                    {gsodRealtimeCheck.map(({ imgSrc, imgSrcActive, index }, mainIndex) => {
                        const text = ANALYTICS_NAV_LINKS[mainIndex];
                        return (
                            <li
                                className={c({ selected: activeIndex === index }, text)}
                                key={text}
                                data-testid={text}
                                onClick={() => {
                                    updateIndex(index);
                                }}
                            >
                                <img src={activeIndex === index ? imgSrcActive : imgSrc} alt="" />
                                {text}
                            </li>
                        );
                    })}
                </ul>
                <section>
                    {analyticsApiCount || diagnoseApiCount ? (
                        <Loader position="absolute" showBackground background="transparent" />
                    ) : (
                        getPage()
                    )}
                </section>
                {filterOpen && (
                    <FilterBar
                        closeFilters={toggleFilterView}
                        setFilters={setFilters}
                        filtersApplied={filtersApplied}
                        // filters={filters}
                        filters={filters}
                        defaultSettings={defaultSettings}
                        filtersMapping={filtersMapping}
                        // defaultFilters={defaultFilters}
                        // defaultFilters={updatedFilterss}
                        defaultFilters={defaultFilters}
                        isFiltersApplied={isFiltersApplied}
                        hideFilterIds={isDiffAnalysisScreen ? ['quartile'] : []}
                        range={range}
                        setRange={setOrgSizeData}
                        dataAtGlance={dataAtGlance}
                    />
                )}
                {realtimePopup && (
                    <RealtimeFilterBar
                        closeFilters={realtimeToggleFilterView}
                        setFilters={setRealtimeFilters}
                        // filtersApplied={filtersApplied}
                        filtersApplied={realtimeFiltersApplied}
                        filters={realtimeFiltersData}
                        defaultSettings={defaultSettings}
                        filtersMapping={filtersMapping}
                        defaultFilters={realtimeDefaultFiltersData}
                        // isFiltersApplied={isFiltersApplied}
                        isFiltersApplied={isRealtimeFiltersApplied}
                        hideFilterIds={isDiffAnalysisScreen ? ['quartile'] : []}
                        range={range}
                        setRange={setOrgSizeData}
                    />
                )}
                {/* {!isClient && (
                    <Button className="feedbackBtn" onClick={() => toggleFeedbackView(true)}>
                        <span>
                            <img src={PenWhite} alt="" />
                        </span>
                        {FEEDBACK}
                        <span>
                            <img src={SmallDown} alt="" />
                        </span>
                    </Button>
                )} */}
                {feedbackOpen && (
                    <Feedback
                        closeFeedback={toggleFeedbackView}
                        defaultSettings={defaultSettings}
                        apiLoadingCount={diagnoseApiCount}
                    />
                )}
                {/* {!isClient ? <ChatBot userAuthToken={token} userName={userName} /> : null} */}
            </div>
        </Layout>
    );
}

Analytics.propTypes = {
    analyticsApiCount: PropTypes.number.isRequired,
    updateFilters: PropTypes.func.isRequired,
    filters: PropTypes.array.isRequired,
    filtersApplied: PropTypes.bool.isRequired,
    filtersFetched: PropTypes.bool.isRequired,
    getFilterData: PropTypes.func.isRequired,
    defaultSettings: PropTypes.object.isRequired,
    filterParams: PropTypes.string.isRequired,
    dataAtGlanceFetched: PropTypes.bool.isRequired,
    getDataAtGlance: PropTypes.func.isRequired,
    getFiltersMapping: PropTypes.func.isRequired,
    filtersMapping: PropTypes.array.isRequired,
    filtersMappingFetched: PropTypes.bool.isRequired,
    defaultFilters: PropTypes.object.isRequired,
    getDefaultYear: PropTypes.func.isRequired,
    defaultYear: PropTypes.number.isRequired,
    diagnoseApiCount: PropTypes.number.isRequired,
    range: PropTypes.array.isRequired,
    setOrgSizeData: PropTypes.func.isRequired,
    dataAtGlance: PropTypes.array.isRequired,
    getRealtimeYear: PropTypes.func.isRequired,
    defaultRealTimeYear: PropTypes.number.isRequired,
    getRealtimeAnalytics: PropTypes.func.isRequired,
    realtimeTotalData: PropTypes.array.isRequired,
    getRealtimeSurveyList: PropTypes.func.isRequired,
    realtimeSurveyList: PropTypes.array.isRequired,
    // new
    getRealtimeFilters: PropTypes.func.isRequired,
    realtimeFiltersData: PropTypes.array.isRequired,
    realtimeDefaultFiltersData: PropTypes.array.isRequired,
    realtimeFiltersParams: PropTypes.string.isRequired,
    realtimeFilterDataFetched: PropTypes.bool.isRequired,
    realtimeTotalDataFetched: PropTypes.bool.isRequired,
    realtimeSurveyListFetched: PropTypes.bool.isRequired,
    updateRealtimeFilters: PropTypes.func.isRequired,
    realtimeFiltersApplied: PropTypes.bool.isRequired,
};

export default Analytics;
